import NewNavbar from "./NewNavbar";
import { useState } from "react";
import Footer from "./Footer";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toast, { Toaster } from "react-hot-toast";

export default function STPMonitoring() {
  const images = [
    {
      id: 1,
      imageUrl:
        "https://res.cloudinary.com/dt8emxboh/image/upload/v1774855963/vyurnu4tre42qapljydy.png",
    },
    {
      id: 2,
      imageUrl:
        "http://res.cloudinary.com/dt8emxboh/image/upload/v1774856018/vm9drjccewyqvhagqque.png",
    },
    {
      id: 3,
      imageUrl:
        "http://res.cloudinary.com/dt8emxboh/image/upload/v1774856710/raria424n6nzl2urdwh0.png",
    },
  ];

  //Book a Demo call api

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Phone validation
    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error("Phone number must be exactly 10 digits");
      return;
    }

    try {
      await axios.post("https://api.livestockify.com/api/admin/queries", {
        name: formData.firstName + " " + formData.lastName,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      });

      toast.success("Message sent successfully ✅");

      // reset form
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong ❌");
    }
  };

  return (
    <>
      <NewNavbar />
      <Toaster position="top-right" reverseOrder={false} />

      <Carousel
        showThumbs={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={3000}
        stopOnHover={true}
        dynamicHeight={true}
        showStatus={false}
        transitionTime={600}
        emulateTouch={true}
        swipeable={true}
        className="h-full"
      >
        {images.map((image) => (
          <div
            key={image.id}
            className="relative w-full h-[2x30px] md:h-[420px] lg:h-[550px] xl:h-[800px] 2xl:h-[850px]"
          >
            <img
              src={image.imageUrl}
              className="w-full h-full object-cover"
              alt={image.description || "carousel image"}
            />
          </div>
        ))}
      </Carousel>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
              Our <span className="text-[#6FAF1E]">Offerings</span> for Smart
              Aqua-Monitoring <span className="text-[#0F6D73]">Solutions</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Explore Kuppismart's intelligent IoT devices designed for
              real-time monitoring and automation of sewage and water treatment
              systems. Our STP solutions integrate multi-parameter sensing,
              continuous connectivity, solar-ready reliability, and automated
              control to ensure complaint, efficient, and stable treatment plant
              operations.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-2 gap-16 mt-16 items-start">
            {/* Product 1 */}
            <div className="text-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726771/cme0iywzd3dabez302cv.png"
                alt="Device"
                className="mx-auto w-64 md:w-72"
              />
            </div>

            {/* Product 2 */}
            <div className="text-center">
              <div className="grid grid-cols-2 gap-6 text-left mt-6 text-sm text-gray-700">
                <div>
                  <h2 className="font-semibold text-[#0F6D73]">
                    Sensors Supported:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Dissolved Oxygen (DO)</li>
                    <li>Water Temperature</li>
                    <li>pH</li>
                    <li>Ammonia</li>
                    <li>ORP</li>
                    <li>Expandable sensor ports</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Monitoring:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Multi-pond monitoring</li>
                    <li>Real-time analytics dashboard</li>
                    <li>Historical trends</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Connectivity:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Wi-Fi / Cellular (4G)</li>
                    <li>Cloud data logging</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">Alerts:</h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>App / SMS / WhatsApp</li>
                    <li>Threshold alerts</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-semibold text-[#0F6D73]">Power:</h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>AC power</li>
                    <li>Solar-ready with battery backup</li>
                    <li>Low-power operation</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Automation:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Aerator automation</li>
                    <li>Pump / feeder integration</li>
                    <li>Rule-based automation</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Deployment:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Multi-pond farms</li>
                    <li>Commercial aquaculture</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Key <span className="text-[#6FAF1E]">Aquaculture Solutions</span>{" "}
              Powered by <span className="text-[#0F6D73]">Kuppismart</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Kuppismart aquaculture devices deliver multi-parameter water
              quality sensing, real-time mobile app monitoring with instant
              alerts, solar-backed reliability, and automation with existing
              aerators and farm equipment.
            </p>
          </div>

          {/* Section 1 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Real-Time</span> Alerts &
                Monitoring & <span className="text-[#0F6D73]"> AI</span>-Driven
                Insights
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                STP data is streamed to the kuppismart platform with the instant
                alerts and AI-based insights that detect abnormal trends,
                predict process deviation and recommend corrective
                actions-enabling operators to respond early and maintain
                treatment efficiency.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726888/ahj0tsfyafvyu027e0ih.png"
                alt="Mobile Monitoring App"
                className="w-[220px] md:w-[280px] lg:w-[320px]"
              />
            </div>
          </div>

          {/* Section 2 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Image */}
            <div className="flex justify-center order-2 md:order-1">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774603480/xlfqxfffar1kdur7ee9e.png"
                alt="Aerator Automation"
                className="w-[260px] md:w-[320px] lg:w-[360px]"
              />
            </div>

            {/* Text */}
            <div className="text-center md:text-left order-1 md:order-2">
              <h3 className="text-xl md:text-2xl font-semibold">
                Multi-Parameter Water Quality {"  "}
                <span className="text-[#6FAF1E]">Monitoring</span>
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Continously measures critical wastewater parameters such as pH,
                dissolved oxygen, temperature, TDS, and other treatment
                indicators using industrial-grade sensors-ensuring stable
                biological processes and complaint discharge quality across STP
                operations.
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                Treatment Equipment{" "}
                <span className="text-[#6FAF1E]">Automation</span>
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Seamlessly integrates with blowers, pumps and dosing systems to
                automatically respond to real-time water conditions-Optimizing
                aeration cycles, chemical dosing, and energy usage while
                reducing manual intervention in plant operations.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774604660/patxxqqrvstyirbtrpvx.png"
                alt="Solar Powered Device"
                className="w-[260px] md:w-[320px] lg:w-[360px]"
              />
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Image */}
            <div className="flex justify-center order-2 md:order-1">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773232816/mvkhkrrkvtwfgf7sthvo.png"
                alt="Aerator Automation"
                className="w-[260px] md:w-[320px] lg:w-[360px]"
              />
            </div>

            {/* Text */}
            <div className="text-center md:text-left order-1 md:order-2">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Solar</span>
                -Ready Reliable Operation
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Kuppismart STP devices support solar power with battery backup,
                ensuring uninterruped monitoring and data transmission even
                during power fluctuations or outages-critical for continuous
                treatment compliance and reporting.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Why Choose <span className="text-[#6FAF1E]">Aqua Sense</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Unlike generic aquaculture monitoring devices, Aqua Sense and Aqua
              Sense Pro combine advanced water sensing, expandable parameters,
              solar-powered operation, and automated aerator control—helping
              farms achieve stable pond conditions and scalable monitoring.
            </p>
          </div>

          {/* Table */}
          <div className="mt-14 overflow-x-auto">
            <table className="w-full min-w-[900px] border-collapse">
              {/* Table Head */}
              <thead>
                <tr className="text-center">
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Feature
                  </th>
                  <th className="py-4 text-[#6FAF1E] text-2xl font-semibold">
                    STP Sense Pro
                  </th>
                  <th className="py-4 text-[#0F6D73] text-2xl font-semibold">
                    STP Sense
                  </th>
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Typical Other System
                  </th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody className="text-sm md:text-base">
                <tr className="">
                  <td className="py-4 text-xl font-medium ">
                    Water Parameters
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    pH, COD, BOD,TSS, DO, Temp, Flow
                  </td>
                  <td className="text-[#0F6D73] text-xl">
                    DO, Temp, pH, TSS, Flow
                  </td>
                  <td className="text-xl">Limited (pH, Temp only)</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Advanced Parameters
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    NH3, NO3, Phosphate,Turbidity
                  </td>
                  <td className="text-[#0F6D73] text-xl">Optional expansion</td>
                  <td className="text-xl">✖ Not Supported</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Real-Time Monitoring
                  </td>
                  <td className="text-xl">✔ Continous + Alerts </td>
                  <td className="text-xl">✔ Continous</td>
                  <td className="text-xl">✔ Limited / Manual </td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Compliance Monitoring
                  </td>
                  <td className="text-xl">✔ CPCB / PCB Ready</td>
                  <td className="text-xl">✔ Basic compliance </td>
                  <td className="text-xl">✖ Manual Reporting</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Automation (Aeration / Pumps )
                  </td>
                  <td className="text-xl">✔ Smart Automation</td>
                  <td className="text-xl">✔ Smart Automation</td>
                  <td className="text-xl">✔ Manual</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Alerts & Notifications
                  </td>
                  <td className="text-xl">AI-based alerts </td>
                  <td className="text-xl">Thresold alerts </td>
                  <td className="text-xl">Basic alerts</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Multi-Tank / Multi-Plant Support
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ Enterprise level</td>
                  <td className="text-[#0F6D73] text-xl">✔ Multi-tank</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Sensor Expansion Ports
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Modular & Scalable
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Expandable </td>
                  <td className="text-xl">Fixed</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Installation</td>
                  <td className="text-[#6FAF1E] text-xl">
                    Plug & deploy + SCADA ready
                  </td>
                  <td className="text-[#0F6D73] text-xl">Easy installation </td>
                  <td className="text-xl">Complex </td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Connectivity</td>
                  <td className="text-[#6FAF1E] text-xl">
                    Wi-Fi / 4G / LoRa / MQTT
                  </td>
                  <td className="text-[#0F6D73] text-xl">Wi-Fi / 4G </td>
                  <td className="text-xl">Wi-Fi Only</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Energy Optimisation
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    Smart aeration control
                  </td>
                  <td className="text-[#0F6D73] text-xl">Limited </td>
                  <td className="text-xl">No Optimisation</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Designed for Shrimp Farms
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">Generic aquaculture</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Automation Intelligence
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Alerts-based</td>
                  <td className="text-[#0F6D73] text-xl">
                    Rule-based automation
                  </td>
                  <td className="text-xl">Minimal</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Farm Scalability</td>
                  <td className="text-[#6FAF1E] text-xl"> ✔ Small–medium</td>
                  <td className="text-[#0F6D73] text-xl"> ✔ Medium–large</td>
                  <td className="text-xl">Medium</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Integration with Existing Equipment
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">Partial</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ================= BOOK DEMO SECTION ================= */}
        <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-bold">
              Book a <span className="text-[#6FAF1E]">Demo</span> Today
            </h2>

            <p className="text-gray-600 mt-6 text-lg max-w-md mx-auto md:mx-0">
              Book a Demo today to discover how Kuppismart can optimise your
              farm with IoT and AI technologies.
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white p-8 rounded-xl shadow-md">
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    First Name
                  </label>
                 

                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter Your First Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Last Name
                  </label>
                

                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter Your Last Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    Phone Number
                  </label>
                 

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Your Phone Number"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Email-ID
                  </label>
                

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email-ID"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-start font-medium mb-1">
                  How can we help you?
                </label>
            

                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Your Message"
                  required
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Button */}
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-3 rounded-md font-medium hover:bg-green-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
